import React, { useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';

// routes
import { GoogleOAuthProvider } from '@react-oauth/google';
import {RenderRoutes } from './routes';
// redux
import { store, persistor } from './redux/store';
// theme
import ThemeConfig from './theme';
// components

import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import LoadingScreen from './components/LoadingScreen';
import NotistackProvider from './components/NotistackProvider';

import DalProvider from './components/authentication/DalProvider';
import BrandedThemeConfig from "./components/igtm/BrandedThemeConfig";
import { CollapseDrawerProvider } from "./contexts/CollapseDrawerContext";
import BrandContextProvider from "./contexts/BrandContext";
import { initGA, trackPageView } from './ga';
import ProfileContextProvider from './contexts/ProfileContext';
import ModeSelector from './components/igtm/ModeSelector';
// ----------------------------------------------------------------------

require('dotenv').config()

initGA();

function TrackPageViews() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

const history = createBrowserHistory();

export default function App() {
  return (
    <HelmetProvider>
      <ReduxProvider store={store}>
        <PersistGate loading={<LoadingScreen />} persistor={persistor}>
          <ThemeConfig>
            <BrandedThemeConfig>
            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_APP_ID}>
                <BrandContextProvider>
                  <ProfileContextProvider>
                    <CollapseDrawerProvider>
                      <RtlLayout>
                        <NotistackProvider>
                          <ModeSelector>
                            <Router history={history}>
                            
                              <DalProvider>
                              <ScrollToTop />
                                <TrackPageViews />
                                  <RenderRoutes/>
                              </DalProvider>
        
                            </Router>
                          </ModeSelector>
                        </NotistackProvider>
                      </RtlLayout>
                    </CollapseDrawerProvider>
                    </ProfileContextProvider>
                </BrandContextProvider>
              </GoogleOAuthProvider>
            </BrandedThemeConfig>
          </ThemeConfig>
        </PersistGate>
      </ReduxProvider>
    </HelmetProvider>
  );
}
